import { ensureTransaction } from './data';

import { updateTransaction } from './api';

// old transitions
export const TRANSITION_REQUEST_PAYMENT = 'transition/request-payment';
export const TRANSITION_REQUEST_PAYMENT_AFTER_ENQUIRY = 'transition/request-payment-after-enquiry';

export const TRANSITION_CONFIRM_PAYMENT = "transition/confirm-payment";
export const TRANSITION_EXPIRE_PAYMENT = 'transition/expire-payment';
export const TRANSITION_EXPIRE = 'transition/expire';
export const TRANSITION_ACCEPT = "transition/accept";
export const TRANSITION_OPERATOR_ACCEPT = "transition/operator-accept";
export const TRANSITION_DECLINE = "transition/decline";
export const TRANSITION_OPERATOR_DECLINE = "transition/operator-decline";
export const TRANSITION_CANCEL = "transition/cancel";
export const TRANSITION_COMPLETE = "transition/complete";
export const TRANSITION_OPERATOR_COMPLETE = "transition/operator-complete";

// new transitions
export const TRANSITION_REQUEST = 'transition/request';

export const TRANSITION_ENQUIRE = 'transition/enquire';
export const TRANSITION_REQUEST_AFTER_ENQUIRY = 'transition/request-after-enquiry';

export const TRANSITION_SEND_OFFER = 'transition/send-offer';
export const TRANSITION_SEND_COUNTEROFFER_BY_CUSTOMER = 'transition/send-counteroffer-by-customer';
export const TRANSITION_SEND_COUNTEROFFER_BY_PROVIDER = 'transition/send-counteroffer-by-provider';
export const TRANSITION_SEND_CALENDAR_LINK = 'transition/send-calendar-link';

export const TRANSITION_APPROVE_OFFER = 'transition/approve-offer';
export const TRANSITION_APPROVE_COUNTEROFFER = 'transition/approve-counteroffer';

export const TRANSITION_CANCELL_OFFER_BY_CUSTOMER = 'transition/cancell-offer-by-customer';
export const TRANSITION_CANCELL_OFFER_BY_PROVIDER = 'transition/cancell-offer-by-provider';

export const TRANSITION_UPLOAD_DOCUMENTS = 'transition/upload-documents';
export const TRANSITION_UPLOAD_SIGNED_DOCUMENTS = 'transition/upload-signed-documents';

export const TRANSITION_REQUEST_OFFER_COMPLETE = 'transition/request-offer-complete';
export const TRANSITION_ACCEPT_OFFER_COMPLETE = 'transition/accept-offer-complete';
export const TRANSITION_DECLINE_OFFER_COMPLETE = 'transition/decline-offer-complete';

export const TRANSITION_OPERATOR_CANCEL_ENQUIRY = 'transition/operator-cancel-enquiry';
export const TRANSITION_OPERATOR_CANCEL_REQUESTED = 'transition/operator-cancel-requested';
export const TRANSITION_OPERATOR_CANCEL_COUNTEROFFER_RECEIVED = 'transition/operator-cancel-counteroffer-received';
export const TRANSITION_OPERATOR_CANCEL_OFFER_RECEIVED = 'transition/operator-cancel-offer-received';

export const TRANSITION_OPERATOR_FINISH_WAITING_FOR_DOCUMENTS = 'transition/operator-finish-waiting-for-documents';
export const TRANSITION_OPERATOR_FINISH_DOCUMENTS_UPLOADED = 'transition/operator-finish-documents-uploaded';
export const TRANSITION_OPERATOR_FINISH_IN_PROGRESS = 'transition/operator-finish-in-progress';
export const TRANSITION_OPERATOR_FINISH_WORK_COMPLETED = 'transition/operator-finish-work-completed';

export const TRANSITIONS_OLD = [
  'transition/request-payment',
  'transition/payment-request',
  'transition/request-payment-after-enquiry',
  'transition/confirm-payment',
  'transition/expire-payment',
  'transition/accept',
  'transition/decline',
  'transition/expire',
  'transition/cancel',
  'transition/complete',
  'transition/review-1-by-provider',
  'transition/review-2-by-provider',
  'transition/review-1-by-customer',
  'transition/review-2-by-customer',
  'transition/expire-customer-review-period',
  'transition/expire-provider-review-period',
  'transition/expire-review-period',
  'transition/request-close-transaction',
  'transition/accept-close-transaction',
  'transition/decline-close-transaction',
  'transition/mark-viewed',
  'transition/request-confirm-quotation',
  'transition/accept-quotation',
  'transition/decline-quotation',
];

/**
 * Actors
 *
 * There are 4 different actors that might initiate transitions:
 */

// Roles of actors that perform transaction transitions
export const TX_TRANSITION_ACTOR_CUSTOMER = 'customer';
export const TX_TRANSITION_ACTOR_PROVIDER = 'provider';
export const TX_TRANSITION_ACTOR_SYSTEM = 'system';
export const TX_TRANSITION_ACTOR_OPERATOR = 'operator';

export const TX_TRANSITION_ACTORS = [
  TX_TRANSITION_ACTOR_CUSTOMER,
  TX_TRANSITION_ACTOR_PROVIDER,
  TX_TRANSITION_ACTOR_SYSTEM,
  TX_TRANSITION_ACTOR_OPERATOR,
];

/**
 * States
 *
 * These constants are only for making it clear how transitions work together.
 * You should not use these constants outside of this file.
 *
 * Note: these states are not in sync with states used transaction process definitions
 *       in Marketplace API. Only last transitions are passed along transaction object.
 */
const STATE_INITIAL = 'initial';
const STATE_REQUESTED = 'requested';
const STATE_ENQUIRY = 'enquiry';

const STATE_OFFER_RECEIVED = 'offer-received';
const STATE_COUNTEROFFER_RECEIVED = 'counteroffer-received';

const STATE_CANCELLED = 'cancelled';

const STATE_WAITING_FOR_DOCUMENTS = 'waiting-for-documents';
const STATE_DOCUMENTS_UPLOADED = 'documents-uploaded';

const STATE_IN_PROGRESS = 'in-progress';

const STATE_WORK_COMPLETED = 'work-completed';
const STATE_DELIVERED = 'delivered';

const STATE_PENDING_PAYMENT = 'pending-payment';
const STATE_PAYMENT_EXPIRED = 'payment-expired';
const STATE_PREAUTHORIZED = 'preauthorized';
const STATE_EXPIRED = 'expired';
const STATE_ACCEPTED = 'accepted';
const STATE_DECLINED = 'declined';

/**
 * Description of transaction process
 *
 * You should keep this in sync with transaction process defined in Marketplace API
 *
 * Note: we don't use yet any state machine library,
 *       but this description format is following Xstate (FSM library)
 *       https://xstate.js.org/docs/
 */
const stateDescription = {
  // id is defined only to support Xstate format.
  // However if you have multiple transaction processes defined,
  // it is best to keep them in sync with transaction process aliases.
  id: 'transaction-process-new/release-1',

  // This 'initial' state is a starting point for new transaction
  initial: STATE_INITIAL,

  // States
  states: {
    [STATE_INITIAL]: {
      on: {
        [TRANSITION_ENQUIRE]: STATE_ENQUIRY,
        [TRANSITION_REQUEST]: STATE_REQUESTED,
      },
    },

    [STATE_ENQUIRY]: {
      on: {
        [TRANSITION_REQUEST_AFTER_ENQUIRY]: STATE_REQUESTED,
      },
    },

    [STATE_REQUESTED]: {
      on: {
        [TRANSITION_SEND_OFFER]: STATE_OFFER_RECEIVED,
      },
    },

    [STATE_OFFER_RECEIVED]: {
      on: {
        [TRANSITION_APPROVE_OFFER]: STATE_IN_PROGRESS,
        [TRANSITION_CANCELL_OFFER_BY_CUSTOMER]: STATE_CANCELLED,
        [TRANSITION_SEND_COUNTEROFFER_BY_CUSTOMER]: STATE_COUNTEROFFER_RECEIVED,
      },
    },

    [STATE_COUNTEROFFER_RECEIVED]: {
      on: {
        [TRANSITION_APPROVE_COUNTEROFFER]: STATE_IN_PROGRESS,
        [TRANSITION_SEND_COUNTEROFFER_BY_PROVIDER]: STATE_OFFER_RECEIVED,
        [TRANSITION_CANCELL_OFFER_BY_PROVIDER]: STATE_CANCELLED,
      },
    },
    [STATE_IN_PROGRESS]: {
      on: {
        [TRANSITION_REQUEST_OFFER_COMPLETE]: STATE_WORK_COMPLETED,
      },
    },
    [STATE_WORK_COMPLETED]: {
      on: {
        [TRANSITION_DECLINE_OFFER_COMPLETE]: STATE_IN_PROGRESS,
        [TRANSITION_ACCEPT_OFFER_COMPLETE]: STATE_DELIVERED,
      },
    },

    [STATE_PENDING_PAYMENT]: {
      on: {
        [TRANSITION_CONFIRM_PAYMENT]: STATE_PREAUTHORIZED,
        [TRANSITION_EXPIRE_PAYMENT]: STATE_PAYMENT_EXPIRED,
      },
    },
    [STATE_PAYMENT_EXPIRED]: {
      on: {},
    },
    [STATE_PREAUTHORIZED]: {
      on: {
        [TRANSITION_EXPIRE]: STATE_EXPIRED,
        [TRANSITION_ACCEPT]: STATE_ACCEPTED,
        [TRANSITION_OPERATOR_ACCEPT]: STATE_ACCEPTED,
        [TRANSITION_DECLINE]: STATE_DECLINED,
        [TRANSITION_OPERATOR_DECLINE]: STATE_DECLINED,
      },
    },
    [STATE_EXPIRED]: {
      on: {},
    },
    [STATE_ACCEPTED]: {
      on: {
        [TRANSITION_CANCEL]: STATE_DECLINED,
        [TRANSITION_COMPLETE]: STATE_DELIVERED,
        [TRANSITION_OPERATOR_COMPLETE]: STATE_DELIVERED,
      },
    },
    [STATE_DECLINED]: {
      on: {},
    },

    [STATE_DELIVERED]: { type: 'final' },
  },
};

// Note: currently we assume that state description doesn't contain nested states.
const statesFromStateDescription = description => description.states || {};

// Get all the transitions from states object in an array
const getTransitions = states => {
  const stateNames = Object.keys(states);

  const transitionsReducer = (transitionArray, name) => {
    const stateTransitions = states[name] && states[name].on;
    const transitionKeys = stateTransitions ? Object.keys(stateTransitions) : [];
    return [
      ...transitionArray,
      ...transitionKeys.map(key => ({ key, value: stateTransitions[key] })),
    ];
  };

  return stateNames.reduce(transitionsReducer, []);
};

// This is a list of all the transitions that this app should be able to handle.
export const TRANSITIONS = getTransitions(statesFromStateDescription(stateDescription)).map(
  t => t.key
);

// This function returns a function that has given stateDesc in scope chain.
const getTransitionsToStateFn = stateDesc => state =>
  getTransitions(statesFromStateDescription(stateDesc))
    .filter(t => t.value === state)
    .map(t => t.key);

// Get all the transitions that lead to specified state.
const getTransitionsToState = getTransitionsToStateFn(stateDescription);

// This is needed to fetch transactions that need response from provider.
// I.e. transactions which provider needs to accept or decline

// export const transitionsToRequested = getTransitionsToState(STATE_PREAUTHORIZED);
// export const transitionsToEnquiry = getTransitionsToState(STATE_ENQUIRY);

/**
 * Helper functions to figure out if transaction is in a specific state.
 * State is based on lastTransition given by transaction object and state description.
 */

const txLastTransition = tx => ensureTransaction(tx).attributes.lastTransition;

export const txIsRequestedContact = tx =>
  getTransitionsToState(STATE_REQUESTED).includes(txLastTransition(tx));

export const txIsEnquired = tx =>
  getTransitionsToState(STATE_ENQUIRY).includes(txLastTransition(tx));

export const txIsOfferReceived = tx =>
  getTransitionsToState(STATE_OFFER_RECEIVED).includes(txLastTransition(tx));


export const txIsInProgress = tx =>
  getTransitionsToState(STATE_IN_PROGRESS).includes(txLastTransition(tx));

export const txIsWaitingForDocuments = tx =>
  getTransitionsToState(STATE_WAITING_FOR_DOCUMENTS).includes(txLastTransition(tx));

export const txIsDocumentUploaded = tx =>
  getTransitionsToState(STATE_DOCUMENTS_UPLOADED).includes(txLastTransition(tx));

export const txIsCanceled = tx =>
  getTransitionsToState(STATE_CANCELLED).includes(txLastTransition(tx));


export const txIsDelivered = tx =>
  getTransitionsToState(STATE_DELIVERED).includes(txLastTransition(tx));


// old need to remove
export const txIsPaymentPending = tx =>
  getTransitionsToState(STATE_OFFER_RECEIVED).includes(txLastTransition(tx));

export const txIsPaymentExpired = tx =>
  getTransitionsToState(STATE_COUNTEROFFER_RECEIVED).includes(txLastTransition(tx));

export const txIsCounterofferReceived = tx =>
  getTransitionsToState(STATE_COUNTEROFFER_RECEIVED).includes(txLastTransition(tx));

// Note: state name used in Marketplace API docs (and here) is actually preauthorized
// However, word "requested" is used in many places so that we decided to keep it.
export const txIsRequested = tx =>
  getTransitionsToState(STATE_IN_PROGRESS).includes(txLastTransition(tx));

export const txIsDeclined = tx =>
  getTransitionsToState(STATE_IN_PROGRESS).includes(txLastTransition(tx));

export const txIsAccepted = tx =>
  getTransitionsToState(STATE_WORK_COMPLETED).includes(txLastTransition(tx));

/**
 * Helper functions to figure out if transaction has passed a given state.
 * This is based on transitions history given by transaction object.
 */

const txTransitions = tx => ensureTransaction(tx).attributes.transitions || [];

const hasPassedTransition = (transitionName, tx) =>
  !!txTransitions(tx).find(t => t.transition === transitionName);

const hasPassedStateFn = state => tx =>
  getTransitionsToState(state).filter(t => hasPassedTransition(t, tx)).length > 0;



// export const txHasBeenAccepted = hasPassedStateFn(STATE_ACCEPTED);
export const txHasBeenDelivered = hasPassedStateFn(STATE_DELIVERED);

/**
 * Other transaction related utility functions
 */

// Check if a transition is the kind that should be rendered
// when showing transition history (e.g. ActivityFeed)
// The first transition and most of the expiration transitions made by system are not relevant
export const isRelevantPastTransition = transition => {
  return [
    TRANSITION_ENQUIRE,
    TRANSITION_REQUEST,
    TRANSITION_REQUEST_AFTER_ENQUIRY,
    TRANSITION_SEND_CALENDAR_LINK,
    TRANSITION_SEND_OFFER,
    TRANSITION_SEND_COUNTEROFFER_BY_CUSTOMER,
    TRANSITION_SEND_COUNTEROFFER_BY_PROVIDER,
    TRANSITION_APPROVE_OFFER,
    TRANSITION_APPROVE_COUNTEROFFER,
    TRANSITION_UPLOAD_DOCUMENTS,
    TRANSITION_UPLOAD_SIGNED_DOCUMENTS,
    TRANSITION_CANCELL_OFFER_BY_CUSTOMER,
    TRANSITION_CANCELL_OFFER_BY_PROVIDER,
    TRANSITION_REQUEST_OFFER_COMPLETE,
    TRANSITION_ACCEPT_OFFER_COMPLETE,
    TRANSITION_DECLINE_OFFER_COMPLETE,

    TRANSITION_CONFIRM_PAYMENT,
    TRANSITION_EXPIRE_PAYMENT,
    TRANSITION_EXPIRE,
    TRANSITION_ACCEPT,
    TRANSITION_OPERATOR_ACCEPT,
    TRANSITION_DECLINE,
    TRANSITION_OPERATOR_DECLINE,
    TRANSITION_CANCEL,
    TRANSITION_COMPLETE,
    TRANSITION_OPERATOR_COMPLETE,
  ].includes(transition);
};

export const getUserTxRole = (currentUserId, transaction) => {
  const tx = ensureTransaction(transaction);
  const customer = tx.customer;
  if (currentUserId && currentUserId.uuid && tx.id && customer.id) {
    // user can be either customer or provider
    return currentUserId.uuid === customer.id.uuid
      ? TX_TRANSITION_ACTOR_CUSTOMER
      : TX_TRANSITION_ACTOR_PROVIDER;
  } else {
    throw new Error(`Parameters for "userIsCustomer" function were wrong.
      currentUserId: ${currentUserId}, transaction: ${transaction}`);
  }
};

export const txRoleIsProvider = userRole => userRole === TX_TRANSITION_ACTOR_PROVIDER;
export const txRoleIsCustomer = userRole => userRole === TX_TRANSITION_ACTOR_CUSTOMER;

// Check if the given transition is privileged.
//
// Privileged transitions need to be handled from a secure context,
// i.e. the backend. This helper is used to check if the transition
// should go through the local API endpoints, or if using JS SDK is
// enough.


// export const isPrivileged = transition => {
//   return [TRANSITION_REQUEST_PAYMENT, TRANSITION_REQUEST_PAYMENT_AFTER_ENQUIRY].includes(
//     transition
//   );
// };

export const isPrivileged = transition => {
  return [TRANSITION_REQUEST, TRANSITION_REQUEST_PAYMENT, TRANSITION_REQUEST_PAYMENT_AFTER_ENQUIRY].includes(
    transition
  );
};

export const isLastTransition = (transaction, transition) => {
  return transaction?.attributes?.lastTransition === transition;
}

export const setViewedForOtherUser = (currentUser, transaction, otherUserId) => {

  const currentTransactionId = transaction?.id?.uuid;

  // const currentUserId = currentUser?.id?.uuid;
  // const customer = transaction.customer;
  // const provider = transaction.provider;

  // const otherUser = [provider, customer].find(u => u?.id?.uuid !== currentUserId);
  // const userId = otherUser.id.uuid;

  return updateTransaction({
    id: currentTransactionId,
    metadata: {
      viewed: { [otherUserId]: false },
    }
  });
}

export const getOtherUserId = (currentUser, transaction) => {
  const currentUserId = currentUser?.id?.uuid;
  const customer = transaction.customer;
  const provider = transaction.provider;

  const otherUser = [provider, customer].find(u => u?.id?.uuid !== currentUserId);
  return otherUser?.id?.uuid;
}